import { render, staticRenderFns } from "./MoleculeContentEditorBlockInputAudio.vue?vue&type=template&id=32089434"
import script from "./MoleculeContentEditorBlockInputAudio.vue?vue&type=script&lang=js"
export * from "./MoleculeContentEditorBlockInputAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports